import React from "react";
import "./style.css";
import { Helmet } from "react-helmet";

import GroupCard from "components/Groups/GroupCard";
//import { Timeline } from 'react-twitter-widgets'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "components/Footer/Footer";
//import TitleSection from "components/TitleBar/TitleSection";
//import SpotLightPk from 'components/spotlightedPK/spotlightedPK';

//import Organizer from 'components/Organizers/Organizers';
//import { current_unix_stamp, timeStampDiff, unixTimeStamp } from "utils/Helper";
import ManageGroupModalButton from "components/Modals/ManageGroupModalButton";

//import Help from "../../Assets/Qicon.png";
import Container from "react-bootstrap/Container";
//import Carousel from "react-bootstrap/Carousel";
//import Button from "../../components/Button/Button";
import axios from 'axios';
//import { events_list_api,search_Presentation_API,events_search_list_api, HeaderConfig, managed_contents, managed_contents_PechaKucha_Inc, myHeaders_Authorized, user_entity_uuid } from "Api/Api";
import { organization_user_access_level, user_access_level, user_Status, user_Status_Ver, org_friendly_url, apiUrl, myHeaders_Authorized, user_entity_uuid } from "Api/Api";
// , myHeaders_Auth_With_Cache_Control, myHeaders_With_Cache_Control, searchUrl
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { withRouter } from "react-router-dom";
// Link,
import { local_routes } from 'utils/Routes';
//import { NavLink } from "react-router-dom";
import home from 'Assets/home.svg';

import UserContext from 'store/UserContext';

class Groups extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      group_data: [],
      loading: true
    };
    
    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
  }

  /*
  componentDidUpdate (prevProps) {
    let { location: { pathname } } = this.props;

    if (prevProps.location.pathname === pathname) return;
    this.routeChanged();
  }

  routeChanged () {
      this.APICalls();
  }
  */

  componentDidMount() {
    if (user_Status === 1 && user_Status_Ver === "1") {
      this.APICalls();
    } else {
      window.location.href = '/';
    }
    //this.routeChanged();
  }

  onSaveCallback = () => {
    this.APICalls();
  }

  //componentDidMount = async function () {
  APICalls = async function () {
    console.log("Groups APICalls",org_friendly_url,organization_user_access_level);
    //this.setState({
    //  loading: true
    //});

    let new_state = {...this.state};

    // API Calls starts here
    let api_promises = [];
    if (this.workspace_base_url) {
      api_promises.push(axios.get(`${apiUrl}organizations/${org_friendly_url}/groups`,myHeaders_Authorized));
    } else {
      api_promises.push(axios.get(`${apiUrl}groups`,myHeaders_Authorized));
    }
    api_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/groups`,myHeaders_Authorized));
    
    let [group_data_response,user_group_data_response] = await Promise.all(api_promises);

    if (this.workspace_base_url) {
      new_state.group_data = group_data_response.data;
    } else {
      new_state.group_data = group_data_response.data.entities;
    }
    
    new_state.group_data.forEach( element => {
      let me_in_group = user_group_data_response.data.some( element2 => element2.entity_uuid === element.entity_uuid );
      if (me_in_group) {
        element.me_in_group = true;
      }
    });
    
    
    new_state.group_data = new_state.group_data.sort((a, b) => a.entity_name.localeCompare(b.entity_name));

    new_state.loading = false;
    
    this.setState(new_state);
  }

  render() {
    if (this.state.loading === true || !this.context.user_info.entity_uuid) {
      return (
        <ActivityIndicator theme="spinner" />
      );
    }
    
    return (
      <React.Fragment>
        <Helmet>
          <title>Pecha Kucha 20x20: Groups</title>
        </Helmet>
        <Container style={{ marginTop: "10px" }}>
          <Row className="justify-content-between">
            <Col xs={8}>
              <h2>Groups</h2>
            </Col>
            <Col xs="auto">
              { (organization_user_access_level === 'admin' || user_access_level === 'admin') &&
              <ManageGroupModalButton
                group_info={{}}
                onSaveCallback={this.onSaveCallback}
              />
              }
            </Col>
          </Row>
          <Row style={{ marginTop: "15px" }}>
            {this.state.group_data.map(item => (
              <Col key={item.entity_uuid} lg={4} sm={12} md={6}>
                <GroupCard
                  key={item.entity_uuid}
                  group_info={item}
                  user_info={this.context.user_info}
                />                      
              </Col>
            ))}
          </Row>
        </Container>
        <Footer 
          homeImg={home}
          homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
          breadcrumbSubPage="Groups"
        />
      </React.Fragment>
      );
    }
}

export default withRouter(Groups);
